import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Table, Button, Form, InputGroup, Spinner, Alert, Card } from 'react-bootstrap';
import api from './api';

function DanisanListesi({ theme }) {
  const [aramaMetni, setAramaMetni] = useState('');
  const [tumDanisanlar, setTumDanisanlar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const danisanlariGetir = useCallback(async () => {
    try {
      const response = await api.get('/diyetisyen/danisanlar');
      setTumDanisanlar(response.data);
    } catch (err) {
      setError('Danışan listesi yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { danisanlariGetir(); }, [danisanlariGetir]);
  
  const filtrelenmisDanisanlar = tumDanisanlar.filter(danisan =>
    `${danisan.ad} ${danisan.soyad}`.toLowerCase().includes(aramaMetni.toLowerCase())
  );

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className={theme === 'dark' ? "text-light" : "text-dark"}>Danışanlarım</h2>
        <Button variant={theme === 'dark' ? "light" : "primary"} onClick={() => navigate('/danisan/yeni')}>
          + Yeni Danışan Ekle
        </Button>
      </div>

      <div className="mb-4">
        <Form.Control
          style={{ 
            backgroundColor: 'var(--bg-secondary)', 
            border: '2px solid var(--ghost-border)', 
            color: 'var(--text-main)', 
            borderRadius: '0.75rem',
            padding: '1rem'
          }}
          placeholder="🩺 Danışan ara (Ad veya Soyad)..."
          value={aramaMetni}
          onChange={(e) => setAramaMetni(e.target.value)}
        />
      </div>

      {filtrelenmisDanisanlar.length > 0 ? (
        <div className="p-4" style={{ backgroundColor: 'var(--bg-secondary)', borderRadius: '1rem', boxShadow: 'var(--card-shadow)' }}>
          <table className="w-100 text-start" style={{ borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--bg-tertiary)' }}>
                <th className="pb-3 text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '1px', color: 'var(--text-muted)' }}>Ad Soyad</th>
                <th className="pb-3 text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '1px', color: 'var(--text-muted)' }}>E-posta</th>
                <th className="pb-3 text-uppercase text-end" style={{ fontSize: '0.75rem', letterSpacing: '1px', color: 'var(--text-muted)' }}>Telefon</th>
              </tr>
            </thead>
            <tbody>
            {filtrelenmisDanisanlar.map(danisan => (
              <tr key={danisan.id} className="border-bottom" style={{ borderColor: 'var(--bg-tertiary)', transition: 'background-color 0.2s' }}>
                <td className="py-4">
                  <div className="d-flex align-items-center gap-3">
                     <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', backgroundColor: 'var(--bg-tertiary)', color: 'var(--accent-primary)', fontWeight: 'bold' }}>
                       {danisan.ad.charAt(0)}{danisan.soyad.charAt(0)}
                     </div>
                     <Link to={`/danisan/${danisan.id}`} className="fw-bold text-decoration-none" style={{ color: 'var(--text-main)', fontSize: '1rem' }}>
                       {danisan.ad} {danisan.soyad}
                     </Link>
                  </div>
                </td>
                <td className="py-4" style={{ color: 'var(--text-muted)' }}>{danisan.eposta || '-'}</td>
                <td className="py-4 text-end" style={{ color: 'var(--text-muted)' }}>{danisan.telefon || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      ) : (
        <Alert variant="info" className="glass-card">
          {aramaMetni ? 'Arama kriterlerine uygun danışan bulunamadı.' : 'Henüz sisteme kayıtlı bir danışanınız yok.'}
        </Alert>
      )}
    </div>
  );
}
export default DanisanListesi;